import { Colors } from '../../../theme/colors';
import { BadgeUserStatus } from './badge-user-status';

export const userStatusToColor: Record<BadgeUserStatus, string> = {
  incomplete: Colors.bookedScannedInProgressGray,
  // A self-registration awaiting approval, so it reads as in-progress rather than as a failure
  pending: Colors.overdueOrange,
  active: Colors.collectedGreen,
  inactive: Colors.cancelledDeletedRed,
  deleted: Colors.cancelledDeletedRed,
  // Red like the other barred states; the label and icon separate it from inactive.
  rejected: Colors.cancelledDeletedRed
};
